import React, { useState } from "react";
import axios from "axios";
import { X } from "lucide-react";

export default function DocumentosCorporativosForm({ onClose, onUploaded }) {
  // Estados locales para manejar los inputs
  const [nombreDocumento, setNombreDocumento] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [archivo, setArchivo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  // Manejar envío del formulario
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!archivo) {
      setErrorMsg("Debes seleccionar un archivo");
      console.error("[Depuración] No se seleccionó archivo");
      return;
    }

    try {
      setLoading(true);
      setErrorMsg(null);

      // Preparar datos para enviar al backend
      const formData = new FormData();
      formData.append("nombre_documento", nombreDocumento);
      formData.append("descripcion", descripcion);
      formData.append("documento", archivo);

      // Depuración: mostrar el contenido del FormData
      for (let pair of formData.entries()) {
        console.log(`[Depuración] FormData: ${pair[0]} =`, pair[1]);
      }
      console.log("Enviando datos para subir documento...", formData);

      const response = await axios.post(
        `/documentos-corporativos`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Respuesta del servidor:", response.data);
      // Depuración: mostrar la respuesta del backend
      console.log("[Depuración] Respuesta del backend:", response);

      // Llamar callback para refrescar la grilla
      if (onUploaded) onUploaded(response.data.documento);

      // Cerrar el modal después de subir
      onClose();
    } catch (error) {
      // Depuración: mostrar el error completo
      if (error.response) {
        console.error("[Depuración] Error de respuesta:", error.response);
        if (error.response.data && error.response.data.errors) {
          const errors = error.response.data.errors;
          setErrorMsg(Object.values(errors).flat().join(", "));
        } else {
          setErrorMsg(
            error.response.data?.mensaje ||
            error.response.data?.message ||
            "Hubo un error al subir el documento"
          );
        }
      } else {
        console.error("[Depuración] Error desconocido:", error);
        setErrorMsg("Hubo un error al subir el documento");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-lg p-6 rounded-lg shadow-lg relative">
        {/* Botón cerrar */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-red-500"
        >
          <X size={22} />
        </button>

        <h2 className="text-xl font-bold mb-4">Subir nuevo documento</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Nombre */}
          <div>
            <label className="block text-sm font-medium">
              Nombre del documento
            </label>
            <input
              type="text"
              value={nombreDocumento}
              onChange={(e) => setNombreDocumento(e.target.value)}
              className="w-full border rounded-lg px-3 py-2 mt-1 focus:ring-2 focus:ring-primary focus:outline-none"
              required
            />
          </div>

          {/* Descripción */}
          <div>
            <label className="block text-sm font-medium">Descripción</label>
            <textarea
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              className="w-full border rounded-lg px-3 py-2 mt-1 focus:ring-2 focus:ring-primary focus:outline-none"
              rows="3"
            />
          </div>

          {/* Archivo */}
          <div>
            <label className="block text-sm font-medium">Archivo</label>
            <input
              type="file"
              onChange={(e) => setArchivo(e.target.files[0])}
              className="w-full border rounded-lg px-3 py-2 mt-1"
              required
            />
          </div>

          {/* Botón enviar centrado */}
          <div className="flex justify-center">
            <button
              type="submit"
              disabled={loading}
              className="bg-primary hover:bg-lime-700 text-white font-bold py-2 px-6 rounded-lg transition disabled:opacity-50"
            >
              {loading ? "Subiendo..." : "Guardar Documento"}
            </button>
          </div>
          <div>
                   {/* Mostrar error si existe */}
          {errorMsg && (
            <p className="flex justify-center text-red-500 text-sm font-medium">{errorMsg}</p>
          )}
          </div>
        </form>

      </div>
    </div>
  );
}
